import { useState } from 'react';
import { X, Mail, Phone, Lock, ArrowRight, Chrome } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './LoginModal.css';

export default function LoginModal({ isOpen, onClose }) {
  const { login, register } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({ name: '', email: '', mobile: '', password: '' });
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isLogin) {
        await login(formData.email || formData.mobile, formData.password);
      } else {
        await register(formData);
      }
      onClose();
    } catch (err) {
      setError(err.message || 'Authentication failed');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content anim-fade-in" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}><X size={20} /></button>
        
        <div className="modal-header">
          <h2>{isLogin ? 'Welcome Back' : 'Create Account'}</h2>
          <p>{isLogin ? 'Login to track your orders and manage addresses' : 'Join KOA for a faster checkout experience'}</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          {!isLogin && (
            <div className="auth-input-group">
              <label>Full Name</label>
              <input 
                type="text" 
                required 
                value={formData.name} 
                onChange={e => setFormData({...formData, name: e.target.value})} 
                placeholder="John Doe"
              />
            </div>
          )}
          <div className="auth-input-group">
            <label>Email or Mobile</label>
            <input 
              type="text" 
              required 
              value={isLogin ? formData.email || formData.mobile : formData.email}
              onChange={e => setFormData({...formData, email: e.target.value})} 
              placeholder="you@example.com"
            />
          </div>
          {!isLogin && (
            <div className="auth-input-group">
              <label>Mobile Number</label>
              <input 
                type="tel" 
                required 
                value={formData.mobile}
                onChange={e => setFormData({...formData, mobile: e.target.value})} 
                placeholder="+91"
              />
            </div>
          )}
          <div className="auth-input-group">
            <label>Password</label>
            <input 
              type="password" 
              required 
              value={formData.password}
              onChange={e => setFormData({...formData, password: e.target.value})} 
              placeholder="••••••••"
            />
          </div>

          <button type="submit" className="btn-primary auth-submit">
            {isLogin ? 'Login' : 'Sign Up'} <ArrowRight size={18} />
          </button>
        </form>

        <p className="auth-switch">
          {isLogin ? "Don't have an account?" : "Already have an account?"}
          <button onClick={() => setIsLogin(!isLogin)}>{isLogin ? 'Sign Up' : 'Login'}</button>
        </p>
      </div>
    </div>
  );
}
